// import cssLogo from '../assets/skills/CSS3.png';
import jsLogo from '../assets/skills/Js.png';
import reactLogo from '../assets/skills/React.png';
import tsLogo from '../assets/skills/TS.png';
import pythonLogo from '../assets/skills/Python.png';
import nodeLogo from '../assets/skills/Nodejs.png';
import flaskLogo from '../assets/skills/Flask.png';
import mongoLogo from '../assets/skills/MongoDB.png';
import postgresLogo from '../assets/skills/PostgreSQL.png';
import awsLogo from '../assets/skills/AWS.png';
import springLogo from '../assets/skills/SpringBoot.png';
import javaLogo from '../assets/skills/Java.png';
import nextLogo from '../assets/skills/Nextjs.png';
import nestLogo from '../assets/skills/Nestjs.png';
import dockerLogo from '../assets/skills/Docker.png';
import reduxLogo from '../assets/skills/Redux.png';
import firebaseLogo from '../assets/skills/Firebase.png';

export const skills = [
  {
    title: 'JavaScript',
    logo: jsLogo,
  },
  {
    title: 'TypeScript',
    logo: tsLogo,
  },
  {
    title: 'Python',
    logo: pythonLogo,
  },
  {
    title: 'Java',
    logo: javaLogo,
  },
  {
    title: 'React',
    logo: reactLogo,
  },
  {
    title: 'Redux',
    logo: reduxLogo,
  },
  {
    title: 'Next.js',
    logo: nextLogo,
  },
  {
    title: 'Node.js',
    logo: nodeLogo,
  },
  {
    title: 'Nest.js',
    logo: nestLogo,
  },
  {
    title: 'Flask',
    logo: flaskLogo,
  },
  {
    title: 'Spring Boot',
    logo: springLogo,
  },
  {
    title: 'Firebase',
    logo: firebaseLogo,
  },
  {
    title: 'MongoDB',
    logo: mongoLogo,
  },
  {
    title: 'PostgreSQL',
    logo: postgresLogo,
  },
  {
    title: 'AWS',
    logo: awsLogo,
  },
  {
    title: 'Docker',
    logo: dockerLogo,
  },
];
